import { Box, Image } from '@chakra-ui/react'
import React from 'react'

const Proceed = () => {
  return (
   <Box margin={"auto"} display={"flex"} justifyContent="center">
      <Image src="https://media0.giphy.com/media/ar6iPm5mO4jJ5vGoTX/giphy.gif?cid=ecf05e472d1505fb1daebfdb3c8e4025cff63181bbc42cd6&rid=giphy.gif&ct=s"/>
    </Box>
  )
}

export default Proceed
